
import React, { useState, useEffect } from 'react';
import Select from "react-select";
import { isMobile } from 'react-device-detect';
import Swal from 'sweetalert2'

const FormUpdate = (props) => {
    const [selectedOptionDocumentType, setSelectedOptionDocumentType] = useState({ label: "Seleccione tipo de documento", value: "" });
    const [selectedOptionCity, setSelectedOptionCity] = useState({ label: "Seleccione la ciudad", value: "" });
    const [errorValues, setErrorValues] = useState(true);
    const token = document.querySelector("[name='csrf-token']").content;
    const [isLoadedUpdate, setIsLoadedUpdate] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    const [document_types, setDocumentTypes] = useState([]);
    const [cities, setCities] = useState([]);
    const [form, setForm] = useState({
        address: "",
        city_id: "",
        document: "",
        phone: "",
        document_type_id: ""
    });

    const customSelectStyles = {
        input: (base) => ({
            ...base,
            fontSize: isMobile ? "16px" : base.fontSize,
        }),

        control: (base) => ({
            ...base,
            fontSize: isMobile ? "16px" : base.fontSize,
        }),

        placeholder: (base) => ({
            ...base,
            fontSize: isMobile ? "16px" : base.fontSize,
        }),
    };

    const handleSubmit = e => {
        e.preventDefault();
    };

    useEffect(() => {
        loadDataInputs();
    }, [])

    const handleChangeAutocompleteCity = (selectedOptionCity) => {
        setSelectedOptionCity(selectedOptionCity);
        setForm({ ...form, ["city_id"]: selectedOptionCity.value })
    }

    const handleChangeAutocompleteDocumentType = (selectedOptionDocumentType) => {
        setSelectedOptionDocumentType(selectedOptionDocumentType);
        setForm({ ...form, ["document_type_id"]: selectedOptionDocumentType.value })
    }

    const validationForm = () => {
        if (form.address != "" &&
            form.city_id != "" &&
            form.document != "" &&
            form.phone != "" &&
            form.document_type_id != ""
        ) {
            setErrorValues(true)
            return true
        }else{
            setErrorValues(false)
            return false
        }
    }

    const messageSuccess = (response) => {
        Swal.fire({
            position: "center",
            icon: `${response.type}`,
            title: `${response.success}`,
            showConfirmButton: false,
            timer: 1500,
        });
    };

    const handleClick = () => {
        if(validationForm()){
            setIsLoadedUpdate(true)
            fetch(`/user/update_user_information`, {
                method: 'PATCH', // or 'PUT'
                body: JSON.stringify(form), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": token,
                    "Content-Type": "application/json"
                }
            })
    
            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                messageSuccess(data);
                props.updateStateUser(data.register);
                props.updateStatus(false);  
                setIsLoadedUpdate(false);
            });
        }
    }

    const loadDataInputs = () => {
        fetch(`/user/load_current_user_data`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": token,
            }
        })
        .then(response => response.json())
        .then(data => {
            setIsLoaded(false);
            setSelectedOptionCity(data.register.city);
            setSelectedOptionDocumentType(data.register.document_type);
            setDocumentTypes(data.document_types);
            setCities(data.cities);
            setForm({ 
                address: data.register.address ? data.register.address : "", 
                city_id: data.register.city.value, 
                document_type_id: data.register.document_type.value,
                document: data.register.document ? data.register.document : "",
                phone: data.register.phone ? data.register.phone : ""
            })
        });
    }

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    return (
        <React.Fragment>        
            <div>
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-md-12 mb-3">
                            <div className="alert alert-primary text-center">
                                <b className='text-white'>Por favor, ten en cuenta que toda la información que se muestra a continuación es obligatoria y debe ser completada para continuar con el pago, ya que Addi requiere estos datos.</b>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <label className='label-admin'>Dirección</label>
                            <input 
                                type="text" 
                                className={`form form-control ${!errorValues && form.address == "" ? "error-class" : ""}`}
                                name='address'
                                disabled={isLoaded}
                                value={form.address}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-6">
                            <label className='label-admin'>Ciudad</label>
                            <input
                                type="hidden"
                                name="value"
                                value={selectedOptionCity.value}
                            />
                            <Select
                                onChange={handleChangeAutocompleteCity}
                                options={cities}
                                styles={customSelectStyles}
                                autoFocus={false}
                                className={`link-form ${!errorValues && form.city_id == "" ? "error-class" : ""}`}
                                value={selectedOptionCity}
                                isDisabled={isLoaded}
                            />
                        </div>

                        <div className="col-md-12">
                            <hr />
                        </div>

                        <div className="col-md-6">
                            <label className='label-admin'>Tipo de documento</label>
                            <input
                                type="hidden"
                                name="value"
                                value={selectedOptionDocumentType.value}
                            />
                            <Select
                                onChange={handleChangeAutocompleteDocumentType}
                                options={document_types}
                                styles={customSelectStyles}
                                autoFocus={false}
                                className={`link-form ${!errorValues && form.document_type_id == "" ? "error-class" : ""}`}
                                value={selectedOptionDocumentType}
                                isDisabled={isLoaded}
                            />
                        </div>

                        <div className="col-md-6">
                            <label className='label-admin'>Documento</label>
                            <input
                                type="number"
                                name="document"
                                onChange={handleChange}
                                value={form.document}
                                className={`form form-control ${!errorValues && form.document == "" ? "error-class" : ""}`}
                            />
                        </div>
                        
                        <div className="col-md-12">
                            <hr />
                        </div>

                        <div className="col-md-12">
                            <label className='label-admin'>Numero de telefono</label>
                            <input
                                type="number"
                                name="phone"
                                onChange={handleChange}
                                value={form.phone}
                                className={`form form-control ${!errorValues && form.phone == "" ? "error-class" : ""}`}
                            />
                        </div>

                        {!errorValues && (
                            <div className="col-md-12 mt-4">
                                <div className="alert alert-danger text-center" role="alert">
                                    <b className='text-white'>Debes de completar todos los campos requeridos</b>
                                </div>
                            </div>
                        )}

                        <div className="col-md-12">
                            <hr />
                        </div>

                        <div className="col-md-12 text-center">
                            <button
                                className='btn btn-primary text-white mr-2 text-capitalize'
                                onClick={() => handleClick()}
                                disabled={isLoadedUpdate}
                            >
                                {isLoadedUpdate ? "Cargando..." : "Actualizar información"}
                            </button>

                            <a
                                className='btn btn-danger text-white text-capitalize'
                                onClick={() => props.closeModal()}
                                disabled={isLoadedUpdate}
                            >
                                Cancelar
                            </a>
                        </div>
                    </div>
                </form>
            </div>
        </React.Fragment>
    );
};


export default FormUpdate;